<template lang="html">
    <el-dialog
      :title="this.$lang.ui.system.l137"
      :visible.sync="dialogVisible"
      width="25%"
      :close-on-click-modal="false"
      :modal="false"
      >
      <p style="margin-top:-20px">{{this.$lang.ui.prompt.l134}}</p>
      <el-input v-model="emailInput" style="width:85%"></el-input>
      <i class="el-icon-circle-plus-outline add" @click="addEmail()"></i>
      <div class="main_list">
        <div class="email-added" v-for="(email, index) in emails" :key="index">
          <span :title="email.email" style="display:inline-block;width:85%">{{email.email}}</span>
          <el-checkbox class="choose" @change="(value)=>chooseEmail(value, index)" v-model="email.checked" :checked="email.checked"></el-checkbox>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">{{this.$lang.ui.form.l128}}</el-button>
        <el-button type="primary" v-if="send" @click="setEmail">{{this.$lang.ui.form.l100}}</el-button>
        <el-button type="primary" v-else plain disabled>{{this.$lang.ui.form.l100}}</el-button>
      </span>
    </el-dialog>
  <!-- </div> -->
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      account: 'account'
    }),
  },
  props: ['toAddEmail', 'projectId'],
  watch: {
    'sendEmails': function (val) {
      if (val.length > 0) {
        this.send = true
      } else if (val.length === 0) {
        this.send = false
      }
    },
    'toAddEmail': function () {
      if (this.toAddEmail === true) {
        this.dialogVisible = true
      }
    }
  },
  data () {
    return {
      dialogVisible: false,
      emails: [],
      emailInput: '',
      page_num: 0,
      page_size: 10,
      sendEmails: [],
      send: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      const body = document.querySelector('body')
      if (body.append) {
        body.append(this.$el)
      } else {
        body.appendChild(this.$el)
      }
    })
  },
  methods: {
    showBox: function () {
      var projectId = this.projectId || localStorage.getItem('projectId')
      this.dialogVisible = true
      // this.toAddEmail = true
      this.emailInput = ''
      this.emails = []
      this.sendEmails = []
      this.getInviteList(projectId, this.page_num, this.page_size)
    },
    addEmail () {
      var checkEmail = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/
      if (!checkEmail.test(this.emailInput)) {
        this.$message({
          message: this.$lang.ui.prompt.l135,
          type: 'error',
          duration: 1200
        })
        return
      }
      let email = this.emailInput.match(/[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/)[0]
      console.log(this.emails)
      // if (this.emails.filter(i =>i.email===email)) {
      //   console.log(1)
      //   this.emailInput = ''
      //   return
      // }
      for (let i = 0; i < this.emails.length; i++) {
        if (this.emails[i].email === email) {
          // console.log(1)
          this.emailInput = ''
          return
        }
      }
      if (email.length > 50) {
        this.$message({
          message: this.$lang.ui.prompt.l165,
          type: 'error',
          duration: 1200
        })
        return
      }
      let item = {
        email: email,
        checked: true
      }
      // if (this._global.arrayHas(this.emails, item.email)) {
      //   this.emailInput = ''
      //   return
      // }
      this.emails.unshift(item)
      this.sendEmails.unshift(item.email)
      this.emailInput = ''
    },
    getInviteList (
      projectId,
      pageNum,
      pageSize
    ) {
      // let item = [{
      //   email: '',
      //   checked: false,
      // }]
      this.$api.ProjectInviteRecord(
        projectId,
        pageNum,
        pageSize,
        response => {
          response.project_invite_record.forEach(i => {
            let item = {
              email: i.email,
              checked: false,
            }
            this.emails.unshift(item)
          })
        })
    },
    setEmail () {
      if (this.sendEmails.length > 0) {
        var projectId = this.projectId || localStorage.getItem('projectId')
        this.$http.post('/cydex/api/v1/invite', {
          'project_id': projectId,
          'user_to': this.sendEmails
        }).then(response => {
          this.dialogVisible = false
          this.$message({
            message: this.$lang.ui.prompt.l136,
            type: 'success',
            duration: 3000
          })
        })
      }
    },
    cancel () {
      this.dialogVisible = false
    },
    chooseEmail (value, index) {
      if (!value) {
        this.sendEmails.splice(index, 1)
      } else {
        this.sendEmails.unshift(this.emails[index].email)
      }
    }
  }
}

</script>

<style lang="css" scoped>
.word {
  display: none;
  position: absolute;
  font-size: 14px;
  padding: 0 10px;
  width: auto;
  background-color: rgba(0, 0, 0, 0.65);
  white-space:nowrap;
  color: #fff;
  right: 60px;
  top: 10px;
  height: 24px;
  line-height: 24px;
  border-radius: 4px;
}
.add-user {
  opacity: 1;
  /* transition: opacity 0.5s ease; */
  position: absolute;
  /*transition: width 1s ease, height 1s ease;*/
  cursor: pointer;
  bottom: 190px;
  left: 4px;
  width: 46px;
  height: 46px;
  line-height: 46px;
  text-align: left;
  font-size: 18px;
  border-radius: 46px;
  text-align: center;
  color: #fff;
  background-color: #007bc5;
  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.35);
}
.add-user i {
  margin-top: 10px;
}
.add {
  display: inline-block;
  cursor: pointer;
  text-align: center;
  padding-left: 12px;
  font-size: 28px;
  color: #409eff;
  vertical-align: middle;
  margin-bottom: 2px;
}
.email-added {
  margin: 14px 0 0 14px
}
.choose {
  cursor: pointer;
  margin-left: 24px;
  zoom: 120%;
}
.main_list {
  max-height: 200px;
  overflow-y:scroll
}
.choose /deep/ .el-checkbox__inner {
  border-radius: 50%
}
</style>
